import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageProfileSettings
{
    constructor(targetElement)
    {
        const webPushKey = targetElement.dataset.webpushkey;
        const addWebPushEl = ele.byQuery("#notificationSettings .device-sub.add");

        this._settings = {
            "WEBPUSH_WORKER": "/webpush_worker.js",
            "currentDeviceId": null,
            "publicKey": null,
            "pushBlocked": false
        };

        if (window.Notification && window.Notification.permission === "denied")
        {
            this._settings.pushBlocked = true;
            const errorEl = ele.byId("pushblocked-error");
            if (errorEl)
            {
                const errorMsg = errorEl.querySelector(".msg");
                errorMsg.innerText = "Check your browser settings, and reload this page.";
                ele.show(errorEl);
            }
        }

        this._settings.publicKey = webPushKey;
        const webPushCheckbox = ele.byQuery("#webpush_scope");
        const pushActive = ele.byQuery("#webpush_scope").checked && !this._settings.pushBlocked;
        if (addWebPushEl && pushActive) ele.hide(addWebPushEl);


        web.getServiceWorkerSubscription(this._settings.WEBPUSH_WORKER, (err, sub) =>
        {
            if (!err)
            {
                if (sub)
                {
                    const subEl = ele.byQuery("#notificationSettings .webpush_subscriptions .webpush_subscription[data-device-id='" + sub.endpoint + "']");
                    if (subEl)
                    {
                        subEl.classList.add("currentDevice");
                        this._settings.currentDeviceId = sub.endpoint;
                    }
                    else
                    {
                        if (addWebPushEl && pushActive) ele.show(addWebPushEl);
                    }
                }
                else
                {
                    if (addWebPushEl && pushActive) ele.show(addWebPushEl);
                }
            }
            else
            {
                if (addWebPushEl) ele.hide(addWebPushEl);
                if (err === "WEBPUSH_UNSUPPORTED")
                {
                    if (platform && platform.os && platform.os.family === "iOS" || platform.os.family === "OS X")
                    {
                        const iosHint = ele.byQuery(".webpush_subscriptions .ios-hint");
                        if (iosHint) ele.show(iosHint);
                    }
                }
            }
        });

        webPushCheckbox.addEventListener("change", () =>
        {
            const subscriptionsEle = ele.byQuery("#notificationSettings .webpush_subscriptions");
            if (subscriptionsEle)
            {
                if (webPushCheckbox.checked)
                {
                    ele.show(subscriptionsEle);
                    const subs = subscriptionsEle.querySelector(".webpush_subscription");
                    if (!subs || subs.length === 0)
                    {
                        if (addWebPushEl) ele.show(addWebPushEl);
                    }
                }
                else
                {
                    ele.hide(subscriptionsEle);
                }
            }
        });

        const saveButton = ele.byId("notificationsavebutton");
        if (saveButton)
        {
            saveButton.addEventListener("click", () =>
            {
                const errorEle = ele.byId("apisave-error");
                if (errorEle) ele.hide(errorEle);
                web.buttons.startSavingAnimButton(saveButton);
                const allSubscriptions = this._getSubscriptionsFromFields();
                this.saveSubscriptions(allSubscriptions, (err) =>
                {
                    if (!err)
                    {
                        web.buttons.stopSavingAnimButton(saveButton);
                    }
                    else
                    {
                        web.buttons.stopSavingAnimButton(saveButton, true, true);
                        if (errorEle)
                        {
                            const errorMsg = errorEle.querySelector(".msg");
                            errorMsg.innerText = err.msg;
                            ele.show(errorEle);
                        }
                    }
                });
            });
        }

        addWebPushEl.addEventListener("click", () =>
        {
            const errorEle = ele.byId("adddevice-error");
            if (errorEle) ele.hide(errorEle);

            const sendErrorEl = ele.byId("sendtest-error");
            if (sendErrorEl) ele.hide(sendErrorEl);

            web.buttons.startSavingAnimButton(addWebPushEl);
            this.registerDevice((error, deviceId, browserName, webPushSubscription) =>
            {
                if (!error)
                {
                    const subscriptions = [];
                    const data = {
                        "topic": addWebPushEl.dataset.topic,
                        "channel": addWebPushEl.dataset.channel,
                        "scope": addWebPushEl.dataset.scope,
                        "deviceId": webPushSubscription.endpoint,
                        "deviceName": browserName,
                        "subscriptionData": webPushSubscription
                    };
                    const patchSub = {
                        ...data,
                        "topic": "PatchInvite"
                    };
                    subscriptions.push(patchSub);
                    const teamSub = {
                        ...data,
                        "topic": "TeamInvite"
                    };
                    subscriptions.push(teamSub);
                    const membershipSub = {
                        ...data,
                        "topic": "Membership"
                    };
                    subscriptions.push(membershipSub);

                    this.saveSubscriptions(subscriptions, (err, r) =>
                    {
                        if (!err && r.success)
                        {
                            window.location.reload();
                        }
                        else
                        {
                            web.buttons.stopSavingAnimButton(addWebPushEl, true, true);
                            if (errorEle)
                            {
                                const errorMsg = errorEle.querySelector(".msg");
                                errorMsg.innerText = err.msg;
                                ele.show(errorEle);
                            }
                        }
                    });
                }
                else
                {
                    web.buttons.stopSavingAnimButton(addWebPushEl, true, true);
                    if (errorEle)
                    {
                        const msgEle = errorEle.querySelector(".msg");
                        if (msgEle) msgEle.innerText = error + ": " + deviceId;
                        ele.show(errorEle);
                    }
                }
            });
        });

        this.registerRemoveListeners();
        this.registerTestWebPushListeners();
    }

    saveAccount()
    {
        const saveButton = ele.byId("accountsavebutton");
        saveButton.innerText = "Working....";
        api.put(
            "user/account/",
            {
                "account_email": ele.byId("account_email").value,
                "account_newsletter": document.getElementById("account_newsletter").checked
            },
            (res) =>
            {
                if (!res.success)
                {
                    console.log("fail ", res);
                }
                else
                {
                    setTimeout(() =>
                    {
                        saveButton.innerText = "Account updated!";
                    }, 500);
                }
            },
            (res) =>
            {
                saveButton.innerText = "Something went wrong: " + res.msg;
                console.log("err res", res);
            }
        );
    }

    deleteAccount(id, userName)
    {
        const controlName = prompt("Please enter your username:", "");
        if (controlName && controlName === userName)
        {
            api.delete(
                "user/" + id + "?userName=" + userName,
                {},
                (res) =>
                {
                    window.location = "/logout";
                },
                (err) =>
                {
                    document.getElementById("errors_delete").innerText = "this did not work as expected...";
                });
        }
        else
        {
            document.getElementById("errors_delete").innerText = "usernames do not match...";
        }
    }

    saveProfile(saveButton)
    {
        web.buttons.startSavingAnimButton(saveButton);
        let website = ele.byId("profile-website").value;
        let errorEle = ele.byId("errors_links");
        if (website.length > 0)
        {
            let error = false;
            if (website.indexOf("https://") === -1 && website.indexOf("http://") === -1) error = true;
            if (website.indexOf(".") === -1) error = true;
            if (error)
            {
                errorEle.innerText = "Website invalid url";
                ele.show(errorEle);
                web.buttons.stopSavingAnimButton(saveButton, true, true);
                return;
            }
            else
            {
                errorEle.innerText = "";
                ele.hide(errorEle);
            }
        }
        else
        {
            ele.hide(errorEle);
        }

        api.put(
            "user/profile/",
            {
                "profile_bio": ele.byId("profile-bio").value,
                "profile_website": website,
                "profile_twitter": ele.byId("profile-twitter").value,
                "profile_facebook": ele.byId("profile-facebook").value,
                "profile_instagram": ele.byId("profile-instagram").value,
                "profile_mastodon": ele.byId("profile-mastodon").value,
                "profile_country": ele.byId("profile-country").value,
                "profile_city": ele.byId("profile-city").value
            },
            (res) =>
            {
                ele.hide(errorEle);
                if (!res.success)
                {
                    web.buttons.stopSavingAnimButton(saveButton);
                    errorEle.innerText = "Something went wrong!";
                    ele.show(errorEle);
                }
                else
                {
                    setTimeout(() =>
                    {
                        web.buttons.stopSavingAnimButton(saveButton);
                        saveButton.innerText = "Profile saved!";

                        setTimeout(() =>
                        {
                            saveButton.innerText = "Save again";
                        }, 3000);
                    }, 500);
                }
            },
            (res) =>
            {
                errorEle.innerText = "Something went wrong: " + res.msg;
                ele.show(errorEle);
                web.buttons.stopSavingAnimButton(saveButton, true, true);
            }
        );
    }

    savePassword()
    {
        const saveButton = ele.byId("passwordSavebutton");
        saveButton.classList.remove("buttonSavingError");
        saveButton.innerText = "Working....";

        api.put(
            "user/password/",
            {
                "password1": ele.byId("password1").value,
                "password2": ele.byId("password2").value
            },
            (res) =>
            {
                saveButton.classList.remove("buttonSavingError");
                if (!res.success)
                {
                    console.log("fail ", res);
                }
                else
                {
                    setTimeout(() =>
                    {
                        saveButton.innerText = "Password changed!";

                        setTimeout(() =>
                        {
                            saveButton.innerText = "Set password";
                        }, 3000);
                    }, 500);
                }
            },
            (res) =>
            {
                saveButton.classList.add("buttonSavingError");
                if (res.msg) saveButton.innerText = res.msg;
                else saveButton.innerText = "Something went wrong";
                console.log("err res", res);

                setTimeout(() =>
                {
                    saveButton.innerText = "Set password";
                    saveButton.classList.remove("buttonSavingError");
                }, 3000);
            }
        );
    }

    registerDevice(cb = null)
    {
        web.registerWebPushWorker(this._settings.WEBPUSH_WORKER, this._settings.publicKey, (err, webPushSubscription) =>
        {
            if (!err)
            {
                this._settings.currentDeviceId = webPushSubscription.endpoint;
                let browserName = "Unknown Browser";
                if (platform) browserName = platform.name + " " + platform.os.family;
                if (cb) cb(null, this._settings.currentDeviceId, browserName, webPushSubscription);
            }
            else
            {
                if (cb) cb(err, webPushSubscription);
            }
        });
    }

    saveSubscriptions(subscriptions, cb = null)
    {
        let body = [];
        subscriptions.forEach((subscription) =>
        {
            const data = {
                "topic": subscription.topic,
                "channel": subscription.channel,
                "scope": subscription.scope,
                "deviceId": subscription.deviceId,
                "deviceName": subscription.deviceName || subscription.deviceId,
                "subscriptionData": subscription.subscriptionData
            };
            body.push(data);
        });

        api.patch("activityfeed/subscriptions", body, (res) =>
        {
            if (cb) cb(null, res);
        }, (e) =>
        {
            if (cb) cb(e);
        });
    }

    _getSubscriptionsFromFields()
    {
        const allSubscriptionEles = ele.byQueryAll("#notificationSettings .subscription");
        const allSubscriptions = [];
        let pushActive = true;
        allSubscriptionEles.forEach((subEle) =>
        {
            let data = { ...subEle.dataset };
            const disable = !subEle.checked;
            if (disable) data.scope = "none";
            if (data.channel === "webpush" && subEle.type === "checkbox")
            {
                pushActive = subEle.checked;
            }
            else
            {
                if (data.channel === "webpush")
                {
                    data = {
                        ...data,
                        "scope": pushActive ? subEle.dataset.scope : "none"
                    };
                }

                if (subEle.dataset.topic === "InvitesAndRequests")
                {
                    const patchSub = {
                        ...data,
                        "topic": "PatchInvite"
                    };
                    allSubscriptions.push(patchSub);
                    const teamSub = {
                        ...data,
                        "topic": "TeamInvite"
                    };
                    allSubscriptions.push(teamSub);
                    const membershipSub = {
                        ...data,
                        "topic": "Membership"
                    };
                    allSubscriptions.push(membershipSub);
                }
                else
                {
                    allSubscriptions.push(data);
                }
            }
        });
        return allSubscriptions;
    }

    unregisterDevice(cb = null)
    {
        web.unregisterWebPushWorker(this._settings.WEBPUSH_WORKER, (unsubErr) =>
        {
            if (!unsubErr)
            {
                if (cb) cb();
            }
            else
            {
                if (cb) cb("NOT_SUBSCRIBED");
            }
        });
    }

    registerTestWebPushListeners()
    {
        const testWebPushEles = ele.byQueryAll("#notificationSettings .webpush_subscriptions .sendTestNotification");
        testWebPushEles.forEach((testWebPushEle) =>
        {
            const clickListener = () =>
            {
                const errorEl = ele.byId("sendtest-error");
                if (errorEl) ele.hide(errorEl);
                web.buttons.startSavingAnimButton(testWebPushEle, "");
                const subEle = testWebPushEle.closest(".webpush_subscription");
                if (subEle)
                {
                    const subId = subEle.dataset.subscriptionId;
                    this.sendWebPushTest(subId, (err, r) =>
                    {
                        if (err)
                        {
                            web.buttons.stopSavingAnimButton(testWebPushEle, true, true);
                            if (errorEl)
                            {
                                const errorMsg = errorEl.querySelector(".msg");
                                if (errorMsg)
                                {
                                    errorMsg.innerText = err.msg;
                                    if (err.msg && (err.msg === "DEVICE_TOKEN_UNSUBSCRIBED" || err.msg === "WEBPUSH_NO_ENDPOINT"))
                                    {
                                        errorMsg.innerHTML += "<br/>We removed your expired subscription, please add the device again!";
                                        subEle.remove();
                                    }
                                    ele.show(errorEl);
                                }
                            }
                        }
                        else
                        {
                            web.buttons.stopSavingAnimButton(testWebPushEle, true);
                        }
                    });
                }
            };
            testWebPushEle.removeEventListener("click", clickListener);
            testWebPushEle.addEventListener("click", clickListener);
        });
    }

    sendWebPushTest(subId, cb)
    {
        if (subId)
        {
            api.post("activityfeed/" + subId, {}, (r) =>
            {
                cb(null, r);
            }, (e) =>
            {
                cb(e, e);
            });
        }
    }

    registerRemoveListeners()
    {
        const removeWebPushEles = ele.byQueryAll("#notificationSettings .webpush_subscriptions .device-sub.remove");
        removeWebPushEles.forEach((removeWebPushEle) =>
        {
            const clickListener = () =>
            {
                const errorEle = ele.byId("apisave-error");
                if (errorEle) ele.hide(errorEle);
                const subEle = removeWebPushEle.closest(".webpush_subscription");
                if (subEle)
                {
                    if (subEle.classList.contains("currentDevice"))
                    {
                        this.unregisterDevice(() =>
                        {
                            const addWebPushEl = ele.byQuery("#notificationSettings .device-sub.add");
                            if (addWebPushEl) ele.show(addWebPushEl);
                        });
                    }
                    subEle.dataset.scope = "delete";
                    ele.hide(subEle);
                    const subscriptionEles = ele.byQueryAll("#notificationSettings .webpush_subscription:not(.hidden)");
                    if (subscriptionEles.length === 0)
                    {
                        const dndHint = ele.byId("dndHint");
                        if (dndHint) ele.hide(dndHint);
                    }
                    const allSubscriptions = this._getSubscriptionsFromFields();
                    this.saveSubscriptions(allSubscriptions, (err) =>
                    {
                        if (err)
                        {
                            if (errorEle)
                            {
                                const errorMsg = errorEle.querySelector(".msg");
                                errorMsg.innerText = err.msg;
                                ele.show(errorEle);
                            }
                        }
                    });
                }
            };
            removeWebPushEle.removeEventListener("click", clickListener);
            removeWebPushEle.addEventListener("click", clickListener);
        });
    }

    deleteApikey(key)
    {
        const errorEl = ele.byId("errors_apikey");
        if (errorEl) ele.hide(errorEl);
        if (confirm("Really delete ?"))
        {
            api.delete(
                "apikey",
                { "key": key },
                (res) =>
                {
                    document.location.reload();
                },
                (res) =>
                {
                    if (errorEl)
                    {
                        const msg = errorEl.querySelector(".msg");
                        if (msg) msg.innerText = res.msg;
                        ele.show(errorEl);
                    }
                }
            );
        }
    }

    createApikey()
    {
        const comment = document.getElementById("apikey-comment").value;
        api.post(
            "apikey",
            { "comment": comment },
            (res) =>
            {
                document.location.reload();
            });
    }

    changeAvatar()
    {
        const id = ele.byId("avatarselect").value;

        api.post(
            "settings/profilePatch/",
            { "id": id },
            (res) =>
            {

            },
            (res) =>
            {

            }
        );
    }

    sendConfirmationEMail()
    {
        document.getElementById("settings_emailconfirm").innerHTML = "<i class=\"icon icon-loader\"></i>";

        api.get("settings/sendConfirmation", (result) =>
        {
            let msg = "an error occured, try again later.";
            if (result.success) msg = "confirmation email sent. check your inbox";
            document.getElementById("settings_emailconfirm").innerText = msg;
        });
    }
}
